import { render, staticRenderFns } from "./damageValidation.pug?vue&type=template&id=74a654bb&lang=pug&external"
import script from "./damageValidation.js?vue&type=script&lang=js&external"
export * from "./damageValidation.js?vue&type=script&lang=js&external"
import style0 from "./damageValidation.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a654bb')) {
      api.createRecord('74a654bb', component.options)
    } else {
      api.reload('74a654bb', component.options)
    }
    module.hot.accept("./damageValidation.pug?vue&type=template&id=74a654bb&lang=pug&external", function () {
      api.rerender('74a654bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damageValidation/index.vue"
export default component.exports